import React, { useState } from "react";
import { No, Yes } from "../../assets/images";
import { useDispatch } from "react-redux";

import { LocationSelect } from "../../components";
import { setVehicle } from "../../redux/slices/addVehicleSlice";

const CarLocation: React.FC = () => {
  const [isReserved, setIsReserved] = useState<boolean>(true);
  const [isPublic, setIsPublic] = useState<boolean>(false);

  const dispatch = useDispatch();

  const handleSelect = () => {
    setIsReserved(!isReserved);
    setIsPublic(!isPublic);
  };

  const handleSelectLocation = (lat: number, lng: number, loc: string) => {
    dispatch(
      setVehicle({
        parkedLocation: {
          longitude: lng,
          latitude: lat,
        },
      })
    );
  };

  return (
    <>
      <div className="flex w-[80%] lg:w-[70%] py-10 border rounded-2xl mx-auto justify-center  h-full  flex-col gap-2 lg:items-center  bg-white">
        <p className=" text-black text-center font-Poppins font-semibold lg:font-medium text-[18px] md:text-[24px] lg:text-[40px]  ">
          Where will the driver find your vehicle?
        </p>
        <div className="flex flex-col  gap-7 w-[90%] mx-auto  lg:w-2/3 ">
          <div className="flex flex-wrap w-full gap-3">
            <ul className="w-full list-outside  list-disc  ">
              <li className=" flex justify-between items-center w-full font-Poppins text-black text-[14px] lg:text-[24px] font-bold   ">
                In a private parking space (Reserved)
                {isReserved === true ? (
                  <img
                    src={Yes}
                    alt=""
                    className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                    onClick={() => handleSelect()}
                  />
                ) : (
                  <img
                    src={No}
                    alt=""
                    className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                    onClick={() => handleSelect()}
                  />
                )}
              </li>
              <li className=" flex justify-between items-center w-full  font-Poppins text-black text-[14px] lg:text-[24px] font-bold  ">
                In a public packing garage{" "}
                {isPublic ? (
                  <img
                    src={Yes}
                    alt=""
                    className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                    onClick={() => handleSelect()}
                  />
                ) : (
                  <img
                    src={No}
                    alt=""
                    className="cursor-pointer h-[25px] w-[30px] lg:w-[50px]"
                    onClick={() => handleSelect()}
                  />
                )}
              </li>
            </ul>
          </div>
          <LocationSelect
            inputId="car-location"
            divId="map-car-location"
            extraStyles=" rounded-md"
            handleSelectLocation={handleSelectLocation}
            mapId="car-location"
            useVehicleLocation={true}
          />
        </div>
      </div>
    </>
  );
};

export default CarLocation;
